/* Public parsing-rules page — a customer-facing explainer of how uploaded values
 * are parsed. Standalone (no app shell): its own brand top bar + a centered reading
 * column. Every value is a design token so it sits inside the Vintage system. */

.page {
  min-height: 100vh;
  background: var(--bg-primary);
  color: var(--fg-secondary);
}

/* ── Brand top bar (matches the style-guide standalone header) ── */
.topbar {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-md);
  height: var(--topbar-h);
  padding: 0 var(--sp-lg);
  background: var(--bg-nav);
  backdrop-filter: saturate(150%) blur(10px);
  border-bottom: 1px solid var(--border-default);
}

.brand {
  display: flex;
  align-items: center;
  gap: var(--sp-sm);
}

.brandMark {
  display: grid;
  place-items: center;
  width: rem(32px);
  height: rem(32px);
  border-radius: var(--radius-md);
  background: var(--button-primary-bg);
  color: var(--fg-on-primary);
  font-family: var(--font-display);
  font-weight: 600;
  font-size: rem(18px);
}

.brandWord {
  font-family: var(--font-display);
  font-size: rem(20px);
  font-weight: 600;
  color: var(--fg-primary);
  letter-spacing: -0.01em;
}

/* ── Reading column ── */
.content {
  max-width: rem(760px);
  margin: 0 auto;
  padding: var(--sp-xl) var(--sp-lg) var(--sp-5xl);
}

/* One parsing rule, rendered as a titled paragraph. */
.rule {
  padding-block: var(--sp-md);
  border-top: 1px solid var(--border-subtle);
}

.ruleTitle {
  margin-bottom: var(--sp-2xs);
}

/* The result cell in the examples table — a positive number reads in the brand
   ink; a "kept as text" value reads dimmed so the distinction is visible. */
.resultNumber {
  font-family: var(--font-mono);
  color: var(--fg-primary);
}

.resultText {
  color: var(--fg-tertiary);
}

.inputCell {
  font-family: var(--font-mono);
  color: var(--fg-secondary);
}
